const invalidMention =
  /<span class="mention" data-index="(\d+)" data-denotation-char="@" data-error="(true|false)" data-id="([^"]+)" data-value="([^"]+)"[^>]*>\uFEFF?<span contenteditable="false">([^<]+)<\/span>\uFEFF?<\/span>/g

const validMention =
  /<span class="mention" data-index="(\d+)" data-denotation-char="@" data-id="([^"]+)" data-value="([^"]+)"[^>]*>\uFEFF?<span contenteditable="false">([^<]+)<\/span>\uFEFF?<\/span>/g

export const convertHtmlWithMentionsToStandardFormat = (input: string): string =>
  input
    .replace(invalidMention, (_, __, ___, ID, value) => `@[${value}](${ID})`)
    .replace(validMention, (_, __, ID, value) => `@[${value}](${ID})`)
